module.exports = __webpack_public_path__ + "static/media/galleryImage04.ef10d65f.jpg";